import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import BudgetCodeForm from '../insights/budget-code-form-new.js';
import { closeCustomerBudgetCodeCreateModal } from '../../actions/customer-budget-codes-actions.js';
import './modal-common.css';
import './modal-create-budget-code.css';

export class ModalCreateBudgetCode extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
    };
  }

  componentWillUnmount() {
    this.successTimeout && window.clearTimeout(this.successTimeout);
  }

  unsetSuccess = () => {
    this.setState(() => {
      return {
        success: false,
      };
    });
  };

  onSuccess = () => {
    this.setState(() => {
      return {
        success: true,
      };
    });
    this.successTimeout = window.setTimeout(this.unsetSuccess, 5000);
  };

  onRequestClose = () => {
    this.props.actions.closeCustomerBudgetCodeCreateModal();
  };

  handleCloseModal = () => {
    this.onRequestClose();
  };

  render() {
    return (
      <Modal
        appElement={document.getElementById('root')}
        isOpen={this.props.openCreateModal}
        onRequestClose={this.onRequestClose}
        onAfterOpen={this.onAfterOpen}
        shouldCloseOnOverlayClick={true}
        className={{
          base: 'modal',
          afterOpen: 'modal_after-open',
          beforeClose: 'modal_before-close',
        }}
        overlayClassName={{
          base: 'modal-overlay',
          afterOpen: 'modal-overlay_after-open',
          beforeClose: 'modal-overlay_before-close',
        }}
        contentLabel="Create New Category Modal"
      >
        <div className="modal-create-budget-code">
          <button className="close-icon" onClick={this.handleCloseModal}>
            &times;
          </button>
          <h3>Create New Category</h3>
          <div className="budget-code-form-new-toggle">
            {!this.state.success && (
              <BudgetCodeForm onSuccess={this.onSuccess} />
            )}
            {this.state.success && (
              <div className="success brand-bg-color-override">
                <p className="success-message">
                  Great! Your new category has been created. &nbsp;You can now
                  add it to past or future orders.
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

ModalCreateBudgetCode.propTypes = {
  actions: PropTypes.shape({
    closeCustomerBudgetCodeCreateModal: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    openCreateModal: state.customerBudgetCodes.openCreateModal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        closeCustomerBudgetCodeCreateModal,
      },
      dispatch
    ),
  };
}

function areStatesEqual(prev, next) {
  return (
    prev.customerBudgetCodes.openCreateModal ===
    next.customerBudgetCodes.openCreateModal
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(ModalCreateBudgetCode);
